const RequiredFieldsNote = () => (
  <p className="text-sm text-gray-400">
    Fält markerade med en asterisk (*) är obligatoriska.
  </p>
);

export default RequiredFieldsNote;
